
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import LoadingScreen from '@/components/slimehabit/LoadingScreen';
import NotFound from '@/pages/NotFound';

// 使用懒加载导入页面组件
const LandingPage = lazy(() => import('@/pages/LandingPage'));
const SlimeHabitLayout = lazy(() => import('@/components/layout/SlimeHabitLayout'));


// SlimeHabit页面 - 统一任务管理
const CorePage = lazy(() => import('@/pages/slimehabit/CorePage'));
const TasksQuestsUnified = lazy(() => import('@/pages/slimehabit/TasksQuestsUnified'));
const EvolutionPage = lazy(() => import('@/pages/slimehabit/EvolutionPage'));
const TreasuryPage = lazy(() => import('@/pages/slimehabit/TreasuryPage'));
const VIPPage = lazy(() => import('@/pages/slimehabit/VIPPage'));
const SettingsPage = lazy(() => import('@/pages/slimehabit/SettingsPage'));
const StatisticsPage = lazy(() => import('@/pages/slimehabit/StatisticsPage'));
const AchievementsPage = lazy(() => import('@/pages/slimehabit/AchievementsPage'));
const HelpPage = lazy(() => import('@/pages/slimehabit/HelpPage'));


const AppRouter: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen message="正在加载应用..." fullScreen />}>
      <Routes>
        {/* 根路由 - 落地页 */}
        <Route path="/" element={<LandingPage />} />
        
        {/* SlimeHabit 应用路由 */}
        <Route path="/slimehabit" element={<SlimeHabitLayout><Outlet /></SlimeHabitLayout>}>
          <Route index element={<CorePage />} />
          <Route path="core" element={<CorePage />} />
          <Route path="tasks" element={<TasksQuestsUnified />} />
          <Route path="quests" element={<Navigate to="/slimehabit/tasks" replace />} />
          <Route path="evolution" element={<EvolutionPage />} />
          <Route path="treasury" element={<TreasuryPage />} />
          <Route path="vip" element={<VIPPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="achievements" element={<AchievementsPage />} />
          <Route path="help" element={<HelpPage />} />
        </Route>
        
        {/* 未匹配的路由显示404页面 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
